import { type FC } from "react";
import { Paper, Stack, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { type MachineGroupStatus } from "@/schemas";

import { MachineGroupStatusIcon } from "../machine-group-status/machine-group-status-icon";
import { getMachineGroupStatusColor } from "../machine-group-status/machine-group-status-utils";

interface ProductionGroupStatusDisplayProps {
	readonly machineGroupsOnline: number;
}

export const ProductionGroupStatusDisplay: FC<ProductionGroupStatusDisplayProps> = ({ machineGroupsOnline }) => {
	let status: MachineGroupStatus = "Offline";
	if (machineGroupsOnline > 0) {
		status = "Online";
	}
	return (
		<Stack
			component={Paper}
			justifyContent="center"
			alignItems="center"
			sx={(theme) => ({
				backgroundColor: getMachineGroupStatusColor(status, theme),
				px: 1,
			})}
		>
			<Stack direction="row" alignItems="center" gap={0.5}>
				<MachineGroupStatusIcon status={status} useColor />
				<Typography sx={{ textWrap: "nowrap" }}>
					{machineGroupsOnline > 0 ? (
						<FormattedMessage
							id="{machineGroupsOnline} Machine Groups Online"
							defaultMessage="{machineGroupsOnline} Machine Groups Online"
							values={{ machineGroupsOnline: machineGroupsOnline }}
						/>
					) : (
						<FormattedMessage id="Machine Groups Unavailable" defaultMessage="Machine Groups Unavailable" />
					)}
				</Typography>
			</Stack>
		</Stack>
	);
};
